import { render } from "./article.vue?vue&type=template&id=1d56094a&scoped=true"
import script from "./article.vue?vue&type=script&lang=js"
export * from "./article.vue?vue&type=script&lang=js"

import "./article.vue?vue&type=style&index=0&id=1d56094a&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-1d56094a"

export default script